import styled from 'styled-components'

interface MainContainerProps {
  isSnackbarAvailable: boolean
  hasCommonFooterUsed?: boolean
}
export const MainContainer = styled.div<MainContainerProps>`
  width: 100%;
  background: #090909;
  ${({isSnackbarAvailable, hasCommonFooterUsed}) =>
    // add height if new common footer is not used
    !hasCommonFooterUsed &&
    `
    height: ${
      isSnackbarAvailable ? 'calc(100vh - 6.5rem)' : 'calc(100vh - 3.5rem)'
    };
  `}

  @media (max-width: 1024px) {
    height: 100%;
    min-height: 0;
    min-width: 0;
  }
`
export const ActionContainer = styled.div.attrs((): {className: string} => ({
  className: 'mobile-common-footer',
}))`
  width: 100%;
  height: 3.5rem;

  @media (max-width: 1024px) {
    height: auto;
  }
`
